import { BaseEntity } from "./base-entity";

export class FormControlData extends BaseEntity {
    constructor(){
        super();
    }

    //ControlID: string = null;
    //IsVisibleCondition: string = null;
    //IsDisabledCondition: string = null;
    //IsVisible: boolean = null;
    //IsDisabled: boolean = null;

    Deserialize(input: any){
        //this.ControlID = input.ControlID;
        //this.IsVisibleCondition = input.IsVisibleCondition;
        //this.IsDisabledCondition = input.IsDisabledCondition;
        //this.IsVisible = input.IsVisible;
        //this.IsDisabled = input.IsDisabled;

        return input;
    }

}